<template>
    <div>
        <h2 class="text-center thank-you-heading">Verify OTP</h2>
        <p class="text-center paragraph">
            Please verify the OTP sent to your e-mail address
        </p>
        <b-form-group id="input-group-1" label="otp-code" label-for="otpcode">
            <b-form-input
                id="otpcode"
                v-model="otpCode"
                v-validate="{
                    required: true,
                    max: 6,
                    //regex: /^([0-9]*)$/
                }"
                type="text"
                required
                name="OTP code"
                autocomplete="no"
                placeholder="Enter OTP code"
            ></b-form-input>
            <span v-if="isError" class="text-center color-red">{{
                isError
            }}</span>
        </b-form-group>
        <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">
                    <popup-button
                        btn-type="button"
                        btn-variant="primary"
                        :btn-label="
                            countDown > 0 ? 'Submit OTP' : 'Resend Code'
                        "
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                        @onClickButton="submitOTP"
                    ></popup-button>
                </div>
            </div>
        </div>
        <p v-if="countDown > 0" class="text-center paragraph fs-13 my-3">
            Resend Code in {{ countDown }} seconds
        </p>
    </div>
</template>

<script>
import request from '@/utils/request'
import PopupButton from '@/components/registration/PopupButton.vue'
import { mapGetters } from 'vuex'
import jwt_decode from 'jwt-decode'

export default {
    components: {
        PopupButton,
    },
    props: {
        data: { type: Object },
    },
    data() {
        return {
            otpCode: '',
            resendDisable: true,
            countDown: 1800,
            isError: '',
        }
    },
    computed: {
        ...mapGetters(['dataSegmentId', 'loading']),
    },
    mounted() {
        this.countDownTimer()
    },
    methods: {
        async submitOTP() {
            this.$store.commit('setLoading', true)

            const result = await this.$validator.validateAll()

            if (result) {
                const formData = {
                    otpCode: this.otpCode,
                    token: this.data.data.token,
                }
                let encryptedForm = this.CryptoJS.AES.encrypt(
                    JSON.stringify(formData),
                    process.env.VUE_APP_CRYPTO_SECERT_KEY
                ).toString()
                const response = await request({
                    url: `/configurations/verify-otp`,
                    method: 'post',
                    data: { data: encryptedForm },
                })

                if (response.status == 200) {
                    // const decodedToken = jwt_decode(data.data.token);
                    this.$emit('verificationStatus', response)
                    // if (data.data.verificationStatus == false) {
                    //     this.isError = data.data.message;
                    // }
                    if (response.status != 200) {
                        this.isError = 'Your code is invalid, try again!'
                    } else {
                        this.isError = ''
                    }
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                }
                this.$store.commit('setLoading', false)
            } else {
                this.$store.commit('setError', this.errors.all()[0])
                this.$store.commit('setLoading', false)
            }
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                this.isError =
                    'Your OTP code is expired, please click resend OTP'
                this.resendDisable = false
            }
        },
        submitResend() {
            this.$emit('reSendOTP')
        },
    },
}
</script>
